module.exports = __webpack_public_path__ + "static/media/nightEps.7ac5834d.svg";